import React, { useState, useEffect } from "react";
import FacilityList from "./FacilityList";
import CreateFacility from "./CreateFacility";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "../../../components/AppToast";
import { createFacility, getallfacility, updateFacility } from "../../../services/facility/facility";
import { getAllPartners } from "../../../services/tenant/tenant";
import { setLoadTable } from "../../../redux/action/skuTable.action";
import { parseOperationalHours } from "../constant/FacilityListColumns";

const FacilityManagement = () => {
  const dispatch = useDispatch();
  const{userDetail} = useSelector((state)=>state.login);
  const [createButton,setCreateButton]=useState(true);
  const { _id } = useSelector((state) => state?.login?.userDetail);
  const [partners, setPartners] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [listVersion, setListVersion] = useState(0);

  // UI modes
  const [isCreating, setIsCreating] = useState(false);
  const [activeFacility, setActiveFacility] = useState(null);
  const [, setLoading] = useState(false);

  const [editingFacilityId, setEditingFacilityId] = useState(null);

  // Fetch partners once
  useEffect(() => {
    const loadPartners = async () => {
      try {
        const res = await getAllPartners(_id);
        console.log("res", res);

        const formatted = res?.map((p) => ({
          name: p.partner_id,
          value: p._id,
        })) || [];
        setPartners(formatted);
      } catch (err) {
        toast.error("Failed to load partners");
      }
    };
    loadPartners();
  }, [_id]);

  useEffect(()=>{
    console.log(userDetail,"userDetail");
    if(userDetail.userType=='PARTNER'){
      setCreateButton(false)
    }
    else
    {
      setCreateButton(true);
    }
  },[userDetail])

  // Handle create new
  const handleCreateClick = () => {
    setIsCreating(true);
    setActiveFacility(null);
    dispatch(setLoadTable({}));
  };

  // Handle view facility
  const handleViewFacility = (rowData) => {
    if (!rowData) {
      toast.error("Invalid facility data");
      return;
    }

    const sendData = {
      Facility_ID: rowData.Facility_ID ?? null,
      Facility_Type: rowData.Facility_Type ?? null,
      Facility_Owner_Type: rowData.Facility_Owner_Type ?? null,
      Facility_Name: rowData.Facility_Name ?? null,
      // Facility_Description: rowData.Facility_Description ?? null,
      partnerId: rowData.partnerId ?? null,
      tenantId: rowData.tenantId ?? null,

      Facility_Address: {
        address1: rowData["Facility_Address.address1"] ?? null,
        address2: rowData["Facility_Address.address2"] ?? null,
        pincode: rowData["Facility_Address.pincode"] ?? null,
        country: rowData["Facility_Address.country"] ?? null,
        city: rowData["Facility_Address.city"] ?? null,
        state: rowData["Facility_Address.state"] ?? null,
      },

      Facility_ManagerDetails: {
        firstName: rowData["Facility_ManagerDetails.firstName"] ?? null,
        lastName: rowData["Facility_ManagerDetails.lastName"] ?? null, // fixed copy-paste
      },

      Facility_ManagerContact: {
        mobile: rowData["Facility_ManagerContact.mobile"] ?? null,
        email: rowData["Facility_ManagerContact.email"] ?? null,
        alternateMobile: rowData["Facility_ManagerContact.alternateMobile"] != ("null" || "" || null) ? rowData["Facility_ManagerContact.alternateMobile"] : "",
      },

      Facility_DockDetails: rowData.Facility_DockDetails ?? null,
      Facility_StorageType: rowData.Facility_StorageType ?? null,
      Facility_Capacity: rowData.Facility_Capacity ?? null,
      Facility_Source: rowData.Facility_Source ?? null,
      Facility_OtherDetails: rowData.Facility_OtherDetails ?? null,

      Facility_OperationalDaysAndHours: parseOperationalHours(rowData.operationalHours)

    };

    setActiveFacility({
      mode: "view",
      initialValues: sendData,
    });
    setIsCreating(false);
  };

  // Handle edit facility
  const handleEditFacility = (rowData) => {
    if (!rowData) {
      toast.error("Invalid facility data");
      return;
    }


    setEditingFacilityId(rowData.id);

    const sendData = {
      Facility_ID: rowData.Facility_ID ?? null,
      Facility_Type: rowData.Facility_Type ?? null,
      Facility_Owner_Type: rowData.Facility_Owner_Type ?? null,
      Facility_Name: rowData.Facility_Name ?? null,
      // Facility_Description: rowData.Facility_Description ?? null,
      partnerId: rowData.partnerId ?? null,
      tenantId: rowData.tenantId ?? null,

      Facility_Address: {
        address1: rowData["Facility_Address.address1"] ?? null,
        address2: rowData["Facility_Address.address2"] ?? null,
        pincode: rowData["Facility_Address.pincode"] ?? null,
        city: rowData["Facility_Address.city"] ?? null,
        state: rowData["Facility_Address.state"] ?? null,
        country: rowData["Facility_Address.country"] ?? null,
      },

      Facility_ManagerDetails: {
        firstName: rowData["Facility_ManagerDetails.firstName"] ?? null,
        lastName: rowData["Facility_ManagerDetails.lastName"] ?? null, // fixed copy-paste
      },




      Facility_ManagerContact: {
        mobile: rowData["Facility_ManagerContact.mobile"] ?? null,
        email: rowData["Facility_ManagerContact.email"] ?? null,
        alternateMobile: rowData["Facility_ManagerContact.alternateMobile"] != ("null" || "" || null) ? rowData["Facility_ManagerContact.alternateMobile"] : "",
      },

      Facility_DockDetails: rowData.Facility_DockDetails ?? null,
      Facility_StorageType: rowData.Facility_StorageType ?? null,
      Facility_Capacity: rowData.Facility_Capacity ?? null,
      Facility_Source: rowData.Facility_Source ?? null,
      Facility_OtherDetails: rowData.Facility_OtherDetails ?? null,

      Facility_OperationalDaysAndHours: parseOperationalHours(rowData.operationalHours)

    };

    setActiveFacility({
      mode: "edit",
      initialValues: sendData,
    });
    setIsCreating(false);
  };

  // Handle submit (create or update)
  const handleSubmit = async (formData) => {
    try {
      const res = await createFacility(formData);
      toast.success(res?.message || "Facility saved successfully");
      closeForm();
      setListVersion((v) => v + 1);
    } catch (err) {
      toast.error("Failed to save facility");
    }
  };


  const handleUpdateSubmit = async (formData) => {
    try {

      if (!editingFacilityId) {
        toast.error("No facility selected for update");
        return;
      }

      const res = await updateFacility(editingFacilityId, formData);
      toast.success(res?.message || "Facility saved successfully");
      closeForm();
      setEditingFacilityId(null);
      setListVersion((v) => v + 1);
    } catch (err) {
      toast.error("Failed to save facility");
    }
  };


  // Handle close
  const closeForm = () => {
    setActiveFacility(null);
    setIsCreating(false);
    dispatch(setLoadTable({}));
    setEditingFacilityId(null);
    setListVersion((v) => v + 1);
  };

  const onlyFormVisible = isCreating || !!activeFacility;

  return (
    <div className="card shadow-lg main-card" style={{ position: "relative" }}>
      <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
        <h4 className="mb-0 h6 fw-semibold">
          {activeFacility
            ? activeFacility.mode === "view"
              ? "View Facility"
              : "Edit Facility"
            : isCreating
              ? "Add New Facility"
              : "Manage Facility"}
        </h4>
      </div>

      {/* Breadcrumbs */}
      {(isCreating || activeFacility) && (
        <nav
          aria-label="breadcrumb"
          className="px-3 py-2 border-bottom bg-light mb-2"
        >
          <ol className="breadcrumb mb-0 align-items-center">
            <li className="breadcrumb-item">
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={closeForm}
              >
                Facility Management
              </button>
            </li>
            <li
              className="breadcrumb-item active fw-semibold text-primary"
              aria-current="page"
            >
              {isCreating
                ? "Create Facility"
                : activeFacility?.mode === "edit"
                  ? "Edit Facility"
                  : "View Facility"}
            </li>
          </ol>
        </nav>
      )}

      <div className="card-body">
        {/* Facility List */}
        {!onlyFormVisible && (
          <FacilityList
            onViewAsn={handleViewFacility}
            onEditAsn={handleEditFacility}
            refreshKey={listVersion}
            showCreateButton={createButton}
            createButtonText="Add New Facility"
            createButtonIcon="bi-plus-circle"
            onCreateClick={handleCreateClick}
            tableData={facilities}
          />
        )}

        {/* Create Form */}
        {isCreating && !activeFacility && (
          <CreateFacility
            onSubmit={handleSubmit}
            onCancel={closeForm}
            submitText="Create Facility"
            cancelText="Back"
            partners={partners}
            readOnly={false}
          />
        )}

        {/* Edit / View Form */}
        {activeFacility && (
          <CreateFacility
            initialValues={activeFacility.initialValues}
            onSubmit={handleUpdateSubmit}
            onCancel={closeForm}
            submitText={
              activeFacility.mode === "edit" ? "Update Facility" : "Close"
            }
            cancelText="Back"
            partners={partners}
            readOnly={activeFacility.mode === "view"}
            isEdit={activeFacility?.mode === "edit"}
          />
        )}
      </div>
    </div>
  );
};

export default FacilityManagement;
